import Long from 'long';
import {SliceRange} from '../../RawChatsStore/pagingUtils';

const PAGE_SIZE = 100;

export default function getSliceRange(index: number, offsetBefore?: Long, offsetAfter?: Long, pageSize: number = PAGE_SIZE): SliceRange {
  if (offsetBefore && offsetAfter) {
    let start = index - offsetAfter.toNumber();
    start = start < 0 ? 0 : start;
    const end = index + offsetBefore.toNumber();
    return {start, end};
  } else if (offsetBefore) {
    let start = index - offsetBefore.toNumber();
    start = start < 0 ? 0 : start;
    const end = index + 1;
    return {start, end};
  } else if (offsetAfter) {
    const start = index + 1;
    const end = index + 1 + offsetAfter.toNumber();
    return {start, end};
  }
  return {start: index + 1, end: index + pageSize};
}